import { makeStyles } from "@material-ui/core";
import qq6 from "./qq6.jpg";

import InstagramEmbed from "react-instagram-embed";

// import {
//   TwitterTimelineEmbed,
//   TwitterShareButton,
//   TwitterFollowButton,
//   TwitterHashtagButton,
//   TwitterMentionButton,
//   TwitterTweetEmbed,
//   TwitterMomentShare,
//   TwitterDMButton,
//   TwitterVideoEmbed,
//   TwitterOnAirButton,
// } from "react-twitter-embed";

const SingleNews = ({ news }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <h1>HEADING is here</h1>
      </div>
      <div className={classes.image1}>
        {/* <img src={qq6} alt="img 1" /> */}
        IMAGE 1
      </div>
      <div className={classes.contents_1_2}>
        <div className="content1 bg-warning">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laudantium
          quis molestias enim culpa neque adipisci saepe maxime eaque, tempore
          autem cumque itaque facere amet assumenda earum unde nihil quos
          libero.
        </div>
        <div className="content2 bg-success">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cumque
          eveniet eaque ea delectus accusantium, quas rerum error dolorem? Ex
          veritatis libero eligendi aliquam nostrum nihil nulla totam, placeat
          architecto consequuntur!
        </div>
      </div>
      <div className={classes.embed}>
        {!true && (
          <iframe
            width="553"
            height="311"
            src="https://www.youtube.com/embed/RE5PZGLPAQw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        )}
        {/* facebook */}
        {false && (
          <iframe
            src={`https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fnetflix%2Fvideos%2F654696262068258%2F&show_text=true&width=380&t=0`}
            width="380"
            height="591"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowfullscreen="true"
          ></iframe>
        )}

        {/* TWITTER */}
        {/* {true && (
          // <TwitterTimelineEmbed
          //   sourceType="profile"
          //   screenName="ANI"
          //   options={{ height: 400,  }}
          // />
          <TwitterTweetEmbed tweetId={"1402663609872703491"} />
        )} */}
        {!true && (
          <InstagramEmbed
            url="
            https://www.instagram.com/p/CQEV7QiFivg/?utm_source=ig_web_copy_link"
            clientAccessToken="123|456"
            maxWidth={320}
            hideCaption={false}
            containerTagName="div"
            protocol=""
            injectScript
            onLoading={() => {}}
            onSuccess={() => {}}
            onAfterRender={() => {}}
            onFailure={() => {}}
          />
        )}
      </div>
    </div>
  );
};
export default SingleNews;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "maroon",
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    width: "100%",
  },
  heading: {
    backgroundColor: "navy",
  },
  image1: { width: "inherit", overflow: "hidden" },
  embed: {
    backgroundColor: "grey",
    width: "100%",
    display: "grid",
    placeItems: "center",
  },
}));
